/**
 * 未交付页面的统一占位。
 *
 * 明确写"待 Px 接入"而不是留白：留白会被当成 bug 报上来，
 * 而写清阶段能让人知道这是计划内、且知道什么时候会有。
 */
import { useAppCapability } from '../capabilityContext';
import { NAV_ITEMS, findNavByPath } from '../nav';

export function ComingSoonPage({ path }: { path: string }) {
  const { preset } = useAppCapability();
  const item = findNavByPath(path);
  const label = item?.label ?? '未知页面';
  const delivery = item?.delivery ?? 'P?';

  return (
    <div className="h-full overflow-y-auto p-6">
      <h1 className="mb-1 text-base font-semibold">{label}</h1>
      <p className="mb-6 text-uiSm text-ink-muted">
        该模块计划于 <span className="font-num text-accent">{delivery}</span> 阶段交付，
        当前工程仅建立了可导航外壳。
      </p>

      <div className="panel max-w-2xl p-4">
        <h2 className="mb-2 text-ui font-semibold text-ink-secondary">已就绪的底座能力</h2>
        <ul className="space-y-1 text-ui text-ink-secondary">
          <li>· 运行环境探测与画质档位（当前：{preset?.tier ?? '…'}）</li>
          <li>· 全局态 / 全屏工作台双布局与统一导航</li>
          <li>· 导演台入口闸门（低配时给出可执行提示而非置灰）</li>
        </ul>
      </div>

      <div className="mt-4 max-w-2xl text-uiSm text-ink-muted">
        其余导航项：
        {NAV_ITEMS.filter((n) => n.path !== path)
          .map((n) => `${n.label}(${n.delivery})`)
          .join('、')}
      </div>
    </div>
  );
}
